import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'Movie'

const myfunction = {
  GetColumns: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetColumns'),
      method: 'get',
      params: data,
    })
  },

  GetData: function (url, data, type) {
    const param = {
      url: setting.getFullUrl(TYPE, url),
      method: type || 'get',
    }

    if (data instanceof FormData) {
      param.data = data
    } else {
      param.params = data
    }
    return request(param)
  },

  // ===== Upload 控制器接口 (AA2 新接口) =====

  /**
   * 查询正在上传的记录
   * @param {object} data - { sssidArray?, startTime?, endTime?, beginIndex?, pageSize? }
   */
  GetUploadingList: function (data) {
    // 处理数组参数 sssidArray，需要转换为 sssidArray=xxx1&sssidArray=xxx2 格式
    const params = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (key === 'sssidArray' && Array.isArray(data[key])) {
        data[key].forEach(val => params.append('sssidArray', val))
      } else if (data[key] !== undefined && data[key] !== null) {
        params.append(key, data[key])
      }
    })
    const url = setting.getFullUrl('Upload', 'GetUploadingList') + '?' + params.toString()
    console.log('[apiVideo] GetUploadingList URL:', url)
    return request({
      url: url,
      method: 'get',
    })
  },

  /**
   * 查询已完成的上传记录
   * @param {object} data - { sssidArray?, startTime, endTime, status?, beginIndex?, pageSize? }
   */
  GetCompletedUploads: function (data) {
    // 处理数组参数 sssidArray，需要转换为 sssidArray=xxx1&sssidArray=xxx2 格式
    const params = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (key === 'sssidArray' && Array.isArray(data[key])) {
        data[key].forEach(val => params.append('sssidArray', val))
      } else if (data[key] !== undefined && data[key] !== null) {
        params.append(key, data[key])
      }
    })
    const url = setting.getFullUrl('Upload', 'GetCompletedUploads') + '?' + params.toString()
    console.log('[apiVideo] GetCompletedUploads URL:', url)
    return request({
      url: url,
      method: 'get',
    })
  },

  /**
   * 获取设备完整上传状态 (进行中 + 已完成)
   * @param {object} data - { sssid, days? }
   */
  GetUploadStatus: function (data) {
    return request({
      url: setting.getFullUrl('Upload', 'GetUploadStatus'),
      method: 'post',
      params: data,
    })
  },

  /**
   * 获取正在上传的数量 (Redis 高性能接口)
   * @returns {Promise<{state: boolean, message: string, value: number}>}
   */
  GetUploadingCount: function () {
    return request({
      url: setting.getFullUrl('Upload', 'GetUploadingCount'),
      method: 'get',
    })
  },

  GetAlarmTaskList: function (data) {
    const params = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        params.append(key, data[key])
      }
    })
    const url = setting.getFullUrl('Upload', 'GetAlarmTaskList') + '?' + params.toString()
    return request({
      url: url,
      method: 'get',
    })
  },

  DeleteAlarmTasks: function (data) {
    return request({
      url: setting.getFullUrl('Upload', 'DeleteAlarmTasks'),
      method: 'post',
      data: data,
    })
  },

  DeleteAllAlarmTasks: function (data) {
    return request({
      url: setting.getFullUrl('Upload', 'DeleteAllAlarmTasks'),
      method: 'post',
      data: data,
    })
  },

  fileDownload: function (datas, name, nodeInfo, urlObj, convertToMp4) {
    if (datas.length == 0) return false

    let param = ''
    if (datas.length > 1) {
      if (name == undefined || name == '') {
        const now = new Date()
        param +=
          now.getFullYear() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') +
          '_' +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0') +
          String(now.getSeconds()).padStart(2, '0')
      } else {
        param += name
      }
      for (let i = 0; i < datas.length; i++) {
        param += ',' + datas[i].file_path.replace(/\\+/g, '/')
      }
      const data = new TextEncoder().encode(param)
      param =
        'batch/' + Array.from(data, (byte) => ('0' + (byte & 0xff).toString(16)).slice(-2)).join('')
    } else {
      param += datas[0].file_path
        .substring(datas[0].file_path.indexOf('Upload') + 7)
        .replace(/\\+/g, '/')
    }

    const isHttps = window.location.protocol === 'http:' ? false : true
    var dvrSer = localStorage.getItem('dvrServer')
    if (dvrSer != undefined) {
      dvrSer = JSON.parse(dvrSer)
    }

    let url =
      'http' +
      (isHttps ? 's' : '') +
      '://' +
      ((!isHttps ? urlObj?.streamUrl : urlObj?.streamUrls) ??
        (nodeInfo?.ip ?? dvrSer.serIp) +
          ':' +
          (isHttps
            ? (nodeInfo?.httpsPort ?? dvrSer.httpsPort)
            : (nodeInfo?.httpPort ?? dvrSer.httpPort))) +
      '/' +
      param

    // 如果需要转换为MP4，将URL中的.avmsg替换为.mp4
    if (convertToMp4) {
      url = url.replace(/\.avmsg/gi, '.mp4')
    }

    const a = document.createElement('a')
    try {
      // 动态创建a标签
      a.href = url
      // 若后端支持，可指定文件名（跨域时可能失效，需后端配合）
      let fileName
      if (convertToMp4 && name) {
        fileName = name
      } else {
        fileName = url.split('/').pop() || 'file'
      }
      a.download = fileName

      // 触发点击并移除标签
      document.body.appendChild(a)
      a.click()
      console.log('click 后')
    } catch (e) {
    } finally {
      document.body.removeChild(a)
    }
    // console.log("click 后2")
    //window.open(url)
    return true
  },
}

export default myfunction
